(() => {
  if (customElements.get('milwaukee-header')) return;
  customElements.define('milwaukee-header', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.toggle = this.querySelector('.mw-header__toggle');
      this.mobile = this.querySelector('.mw-header__mobile');
      this.desktopDetails = [...this.querySelectorAll('.mw-header__dropdown')];
      this.toggle.addEventListener('click', () => this.setOpen(this.mobile.hidden), options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          if (!this.mobile.hidden) this.setOpen(false, true);
          this.desktopDetails.forEach(details => {
            if (details.open) { details.open = false; details.querySelector('summary').focus(); }
          });
        }
        if (event.key === 'Tab' && !this.mobile.hidden) {
          const focusable = [...this.querySelectorAll('a, button, input:not([type=hidden]), summary')].filter(el => el.getClientRects().length);
          const first = focusable[0], last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      }, options);
      this.desktopDetails.forEach(details => details.addEventListener('toggle', () => {
        if (details.open) {
          this.desktopDetails.forEach(other => { if (other !== details) other.open = false; });
          const input = details.querySelector('input[type=search]');
          if (input) input.focus();
        }
      }, options));
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.desktopDetails.forEach(details => { details.open = false; });
      }, options);
      this.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!this.contains(document.activeElement)) this.desktopDetails.forEach(details => { details.open = false; });
        });
      }, options);
      window.addEventListener('resize', () => {
        if (window.innerWidth >= 1000) this.setOpen(false);
        else this.desktopDetails.forEach(details => { details.open = false; });
        this.measure();
      }, options);
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this);
      this.measure();
    }
    measure() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
      this.style.setProperty('--mw-header-top', `${Math.max(0, this.getBoundingClientRect().top)}px`);
    }
    setOpen(open, focus = false) {
      if (open === !this.mobile.hidden) return;
      this.mobile.hidden = !open;
      this.toggle.setAttribute('aria-expanded', String(open));
      this.toggle.setAttribute('aria-label', open ? 'Menu sluiten' : 'Menu openen');
      this.classList.toggle('is-open', open);
      if (open) {
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.measure();
      } else {
        document.body.style.overflow = this.previousOverflow || '';
      }
      if (focus) this.toggle.focus();
    }
    disconnectedCallback() {
      this.setOpen(false);
      this.controller.abort();
      this.observer.disconnect();
    }
  });
})();
